"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ScriptLoader = require("../ScriptLoader");
const GOOGLE_RECAPTCHA_BASE_URL = "https://www.google.com/recaptcha/enterprise.js";
const GOOGLE_RECAPTCHA_KEY = "grecaptcha";
const loadReCAPTCHAScript = async function (reCAPTCHAKey) {
  return await (0, _ScriptLoader.loadScript)(`${GOOGLE_RECAPTCHA_BASE_URL}?render=${reCAPTCHAKey}`, GOOGLE_RECAPTCHA_KEY);
};
var _default = exports.default = loadReCAPTCHAScript;